/** @jsx isolateComponent */
import { Fragment } from 'react';
import { isolateComponent } from '@zapier/common-utils';
import { css } from '@emotion/core';
import dynamic from 'next/dynamic';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const ClientSideApp = dynamic(
  () => import('@zapier/editor').then(({ EditorApp }) => EditorApp) as any,
  { ssr: false }
);

const standaloneEditorTagStyle = css`
  position: fixed;
  bottom: 4px;
  left: 4px;
  font-size: 8px;
  opacity: 0.5;
`;

export default function Editor() {
  return (
    <Fragment>
      <ClientSideApp />
      <div css={standaloneEditorTagStyle}>
        ver. {publicRuntimeConfig.COMMIT_HASH.substring(0, 8)}
      </div>
    </Fragment>
  );
}
